import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledPageFormatter = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  background-color: ${theme.colors.page_background};

  & .right-content {
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.page_background};
  }
  & .page-container {
    display: flex;
    flex-direction: column;
    background-color: ${theme.colors.page_background};
    height: calc(100vh - 72px);
    overflow: auto;
    padding: 0 26px 12px 32px;
    scrollbar-gutter: stable !important;
    overscroll-behavior: none;
  }
  .right-content.open {
    width: calc(100% - ${theme.variables.sidebar_big_width});
    min-width: calc(100% - ${theme.variables.sidebar_big_width});
  }

  .right-content.close {
    width: calc(100% - ${theme.variables.sidebar_hide_width});
    min-width: calc(100% - ${theme.variables.sidebar_hide_width});
  }
  .right-content.mobile {
    width: 100%;
    min-width: 100%;
  }
  .sidebar-overlayer {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.11);
    z-index: 98;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.MD}px) {
    .right-content.open,
    .right-content.close {
      width: 100%;
    }
  }
`;
